import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-add1",
  "use": "icon-add1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add1\"><defs><style type=\"text/css\"></style></defs><path d=\"M816 816m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z\" p-id=\"1941\" /><path d=\"M512 968a456 456 0 1 1 395.76-229.36 32 32 0 0 1-55.52-32 392 392 0 1 0-145.44 145.44 32 32 0 0 1 32 55.52A456 456 0 0 1 512 968z\" p-id=\"1942\" /><path d=\"M704 544H320a32 32 0 0 1 0-64h384a32 32 0 0 1 0 64z\" p-id=\"1943\" /><path d=\"M512 736a32 32 0 0 1-32-32V320a32 32 0 0 1 64 0v384a32 32 0 0 1-32 32z\" p-id=\"1944\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/add1.svg
// module id = 1HcA
// module chunks = 31